import type { TError, TTrendingTagsResponse } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

export const useGetTrendingTagsQueryKey = (spaceId: string) => [ENTITY, 'widgets', spaceId, 'trending-tags'];

/**
 * Hook to fetch the top tags used on posts in a space over the last 7 days.
 * Each tag's `value` is a feed `tags` filter identifier, so it can be applied
 * as a filter directly on click.
 *
 * @param spaceId - Feed space ID (UUID)
 */
export const useGetTrendingTags = (spaceId: string) => {
  return useQuery<TTrendingTagsResponse, TError>({
    queryKey: useGetTrendingTagsQueryKey(spaceId),
    queryFn: async () => {
      const res = await axios.get<TTrendingTagsResponse>(`/community-hub/spaces/${spaceId}/widgets/trending-tags`);
      return res.data;
    },
    enabled: !!spaceId,
    staleTime: 5 * 60 * 1000, // 5 minutes — matches the API-side cache window
  });
};
